export default "__VITE_ASSET__BVqL4NgA__"